<template>
  <div class="loading">
    <img :src="loadImg" alt="" />
  </div>
</template>

<script>
export default {
  props: {
    loadImg: {
      type: String
    }
  },
  data() {
    return {
    }
  },
  watch: {
  },
  methods: {
  }
}
</script>

<style scoped lang="less">
.loading{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  img{
    width: 100%;
    display: block;
  }
}
</style>